window.AccountingCode = {

	/**
	 *
	 * @param {Integer} acid
	 * @returns {undefined}
	 */
	edit : function(acid){
		acid = undefined === acid ? "" : acid;
		var options = {
			title	: acid.length > 0 ? Loc.g("Modification d'un code comptable") : Loc.g("Ajout d'un code comptable"),
			width	: 550,
			buttons	: [
                {
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#accountingCodeForm").submit();
					}
				}
			],
			callback	: function(){
				var formId = "accountingCodeForm";

				var options = {
					data	: {
						action : 'recordAccountingCode'
					},
					success	:function(data){
						var formIsOk = MyForm.processJson(data, "accountingCodeForm");

						if(formIsOk){
							MyWindow.close();
                            Utils.reload();
						}
					},
					dataType:"json"
				};

				MyForm.prepare(formId, "accountingCharts", options, true);
				MyFacture.initEvent("#"+formId);
			}
		};
		MyWindow.load("accountingCharts", {action : "accountingCodeForm", acid : acid}, options);
	},


	/**
	 *
	 * @param {Integer} acid
	 * @returns {undefined}
	 */
	confirmDelete : function(acid){
		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'un code comptable"),
			buttons		: [
                {
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Valider"),
					click	: function(){
						$(this).dialog("close");

						MyFacture.post(
							"accountingCharts",
							{
								action	: "deleteAccountingCode",
								'deleteAccountingCode_id'	: acid
							},
							function(data){
								if (data.form.status == "failed") {
									Push.error(data.form.fields[0].msg);
								} else {
                                    Utils.reload();
								}
							},
							"json"
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Valider pour supprimer le code comptable"), options);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	preparePaymentsCodeForms : function(){

		$('form').on('submit', function(){
			console.log('submit');
			var $form = $(this);

			$.ajax({
				url			: '/?_f=accountingCharts',
				type		: 'POST',
				dataType	: 'json',
				data		: 'action=recordPaymediumsAccountingCodes&'+$(this).serialize(),
				beforeSend	: function(){
					$form.append('<i class="fa fa-spin fa-spinner img-preloader"></i>');
				},
				success		: function(data){
					$form.find('.img-preloader').remove();
				}
			});

			return false;
		});

		$('select').on('change', function(){
			$(this).closest('form').submit();
		});
	}
};


window.AccountingPrefs = {
	/**
	 *
	 * @returns {undefined}
	 */
	init : function(){
		MyFacture.customForm('#account');
	},


	/**
	 *
	 * @returns {undefined}
	 */
	prepareJournalsForm : function(){
		var formId		= "journalsForm";
		var options		= {
			data	: {
				action : "journalsRecord"
			},
			success	: function(data){
				Utils.reload();
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "accounting_prefs", options, true);
		MyFacture.initEvent("#"+formId);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	prepareAccountingChartForm : function(){
		var formId		= "accountingChartForm";
		var options		= {
			data	: {
				action : "accountingChartRecord"
			},
			success	: function(data){
				Utils.reload();
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "accounting_prefs", options, true);
		MyFacture.initEvent("#"+formId);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	prepareAnalyticAccountingForm : function(){
		var formId		= "analyticAccountingForm";
		var options		= {
			data	: {
				action : "analyticAccountingRecord"
			},
			success	: function(data){
				var formIsOk = MyForm.processJson(data, "analyticAccountingForm");
				if(formIsOk){
					Utils.reload();
				}
			},
			dataType:"json"
		};

		$("#apref_hasAnalytics").on('click',function(){
			if($(this).prop('checked')){
				$('.analytics').show();
			}else{
				$('.analytics').hide();
			}
		});

		MyForm.prepare(formId, "accounting_prefs", options, true);
		MyFacture.initEvent("#"+formId);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	prepareAuxiliaryAccountingForm : function(){
		var formId		= "auxiliaryAccountingForm";
		var options		= {
			data	: {
				action : "auxiliaryAccountingRecord"
			},
			success	: function(data){
				var formIsOk = MyForm.processJson(data, formId);
				if(formIsOk){
					Utils.reload();
				}
			},
			dataType:"json"
		};

		$("#apref_useThirdAux").on('click',function(){
			if($(this).prop('checked')){
				$('.thirdAux').show();
			}else{
				$('.thirdAux').hide();
			}
		});

		$('#apref_defaultThirdAux').on('change', function(){
			$('#apref_defaultThirdAux2').val(this.value);
		});

		$('#apref_generateAll').on('change', function() {
			if ($("#apref_generateAll").is(':checked')) {
				$('#apref_generateAllOveride').parents('.form-group').show();

			} else {
				$('#apref_generateAllOveride').parents('.form-group').hide();
				$("#apref_generateAllOveride").prop('checked', false);
			}
		});
		$('#apref_generateAllOveride').on('change', function(){
			if ($("#apref_generateAllOveride").is(':checked')) {
				MyWindow.alert(Loc.g("Les codes auxiliaires de tous vos clients et fournisseurs vont être re-calculés. Vous recevrez un mail quand l‘opération sera terminée."), {type: "confirm"});
			}
		});

		MyForm.prepare(formId, "accounting_prefs", options, true);
		MyFacture.initEvent("#"+formId);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	prepareAutomaticRecordingForm : function(){
		var formId		= "automaticRecordingForm";
		var options		= {
			data	: {
				action : "automaticRecordingRecord"
			},
			success	: function(data){
				Utils.reload();
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "accounting_prefs", options, true);
		MyFacture.initEvent("#"+formId);
	},

	/**
	 *
	 * @returns {undefined}
	 */
	prepareExportFormatForm : function(){
		var formId		= "exportFormatForm";
		var options		= {
			data	: {
				action : "exportFormatRecord"
			},
			success	: function(data){
				Utils.reload();
			},
			dataType:"json"
		};

		MyForm.prepare(formId, "accounting_prefs", options, true);
		MyFacture.initEvent("#"+formId);

		$("#availableFields").sortable({
			items		: 'li',
			connectWith : $("#map"),
			placeholder : '.ui-state-highlight',
			handle		: '.handler',
			cancel		: '.cancel',
			update		: function() {
				AccountingPrefs.updateColumns();
			}
		});

		$("#map").sortable({
			items		: 'li',
			connectWith : $("#availableFields"),
			placeholder : '.ui-state-highlight',
			handle		: '.handler',
			cancel		: '.cancel',
			update		: function(){

				var hash	= $(this).sortable('serialize');
				// Sanitize Hash
				var reg		= new RegExp("&", "g");
				var reg2	= new RegExp("field\\[\\]\\=", "g");

				var tabhash = hash.split(reg);

				for(var cpt = 0; cpt < tabhash.length; cpt++){
					tabhash[cpt] = tabhash[cpt].replace(reg2, "");
				}

				$('#amap_fields').val(tabhash.join(";"));

				AccountingPrefs.updateColumns();
			}
		});

		var maxHeight = Math.max($('.chartofaccountprefs').height(), $('.auxandanalyticsprefs').height());
		$('.auxandanalyticsprefs').height(maxHeight);
		$('.chartofaccountprefs').height(maxHeight);
	},

	updateColumns: function(){
		var sortContainers = [$('#map'), $("#availableFields")];

		sortContainers.forEach(function(container){
			container.find('li.noColumn').toggleClass('hidden', (container.find('li').not('.noColumn').length > 0));
		});

	},

	/**
	 *
	 * @param {Object} data
	 * @returns {undefined}
	 */
	recordPrefsCallback : function(data){
		var formIsOk = MyForm.processJson(data, "accoutingPrefsForm");
		if(formIsOk) {
			MyWindow.alert(Loc.g("Vos préférences ont bien été mises à jour"), {type: "confirm"});
		} else {
			MyWindow.alert(Loc.g("Certaines informations sont manquantes, vérifiez vos préférences"), {type: "error"});
		}
	},


	/**
	 *
	 * @param {Object} data
	 * @returns {undefined}
	 */
	displayMap : function(data){
		$("#map, #availableFields").empty();
		$("#map, #availableFields").sortable("refresh");
		for (var cpt=0;cpt < data.availableFields.length;cpt++){
			var field = data.availableFields[cpt];
			$("#availableFields").append('<li id="field-'+field.id+'"><a href="javascript:;" class="handler"><i class="fa fa-arrows"></i></a>'+field.fieldLabel+'</li>');
		}
		for (var cpt=0;cpt < data.fieldset.length;cpt++){
			var field = data.fieldset[cpt];
			$("#map").append('<li id="field-'+field.id+'"><a href="javascript:;" class="handler"><i class="fa fa-arrows"></i></a>'+field.fieldLabel+'</li>');
		}
	}
};


window.AccountingEntries = {

	/**
	 *
	 * @returns {undefined}
	 */
	init : function(){
	},


	/**
	 *
	 * @returns {undefined}
	 */
	prepareExportForm : function(){

		var options = {
			success:function(data){},
			dataType:"json"
		};

        MyForm.prepare("exportJournalForm", "accountingJournal&action=exportListing", options, true);
		MyFacture.initEvent();
	},


	/**
	 *
	 * @returns {undefined}
	 */
	prepareFilterForm: function(){

		$('.filter_toplabel').unbind('click').click(function(){
			$(this).next().slideToggle('fast');
			MyFacture.customForm();
		});

		var formid	= "";
		var list	= '';

		var journal = $('input[name=journal]').val();
		formid = "accountingentries"+journal+"FilterForm";
		list = "accountingentries"+journal+"Listing";

		$('.selectPeriod').on('change', function(){

			var range = $(this).val();

			if(range === 'custom'){
				$('#customDate').show();
				MyFacture.customForm();
			}else{
				$('#customDate').hide();
			}
		});

		var options = {
			data	: {
				action : 'updateListing'
			},
			success : function(data){
				AccountingEntries.processFilterForm(data);
			},
			dataType:"json"
		};

		MyForm.prepare(formid, "accountingJournal", options);
		MyFacture.customForm();
    },


	/**
	 *
	 * @param {Object} data
	 * @returns {undefined}
	 */
	processFilterForm: function(data) {
		var journal = $('input[name=journal]').val();
		var prefix = "accountingentries"+journal+"Listing";
		var metadataName = "accountingentries"+journal+"_metadatas";
		var metadata =  data[metadataName];

		Listing.refresh(prefix, data, metadata);
	},

	/**
	 *
	 * @param {Integer} pagenum
	 * @param {Integer} nbpage
	 * @returns {undefined}
	 */
	buildPagenum: function(pagenum, nbpage){},


	/**
	 *
	 * @param {integer} linkedid
	 * @param {string} linkedtype
	 * @returns {undefined}
	 */
	removeRecorded : function(linkedid, linkedtype){
		MyFacture.post(
			"accountingJournal",
			{
				action		: 'removeRecorded',
				linkedid	: linkedid,
				journal		: linkedtype
			},
			function(data){
				AccountingEntries.removeRecordedCallback(data);
			},
			'json');
	},

	/**
	 *
	 * @param {Object} data
	 * @returns {undefined}
	 */
	removeRecordedCallback : function(data){
		Utils.reload();
	},


	/**
	 *
	 * @param {integer} linkedid
	 * @param {string} linkedtype
	 * @returns {undefined}
	 */
	viewEntries : function(linkedid, linkedtype){

		var options = {
			title	: Loc.g("Ecritures comptables"),
			buttons	: [
				{
					text	: Loc.g("Fermer"),
					click	: function(){
						$(this).dialog("close");
					}
				}
			],
			width: 1200,
			height: 500
		};

		if(linkedtype === 'bank'){
			options.buttons = [
				{
					text	: Loc.g("Fermer"),
					click	: function(){
						$(this).dialog("close");
					}
				}
			];
		}

		var fileOpt = {
			action		: "listDocEntries",
			linkedid	: linkedid,
			journal		: linkedtype,
			callback	: function(){
				AccountingEntries.loadUnmarkButton(linkedid, linkedtype);
			}
		};

		fileOpt = $.extend(true, fileOpt, DocOverview.getProperties(['docid', 'doctype']));
		MyWindow.load("accountingJournal", fileOpt, options);
	},


	/**
	 *
	 * @param {Integer} linkedid
	 * @param {String} linkedtype
	 * @returns {undefined}
	 */
	makeRecordable : function(linkedid, linkedtype){
		MyFacture.post(
			"accountingJournal",
			{
				action		: 'makeRecordable',
				linkedid	: linkedid,
				journal		: linkedtype
			},
			function(data){
				AccountingEntries.makeRecordableCallback(data);
			},
			'json'
		);
	},


	/**
	 *
	 * @param {Object} data
	 * @returns {undefined}
	 */
	makeRecordableCallback : function(data){
		Utils.reload();
	},


	/**
	 *
	 * @param {Integer} linkedid
	 * @param {String} linkedtype
	 * @returns {undefined}
	 */
	loadUnmarkButton : function(linkedid, linkedtype){
		return true;
	},


	/**
	 *
	 * @param {String} listing
	 * @returns {undefined}
	 */
	exportEntries : function(listing){
		var journal 		= "";
		var listingToUpdate = listing;

		switch(listing){
			case "accountingentriespurchaseListing":
				journal = "purchase";
				break;
			case "accountingentriessellListing":
				journal = "sell";
				break;
			case "accountingentriescashtillListing":
				journal = "cashtill";
				break;
			case "accountingentriesbankListing":
				journal = "bank";
				break;
			case "accountingentriesreconciliatedListing":
				journal = "reconciliated";
				break;
		}

		var options = {
			title: Loc.g("Export CSV"),
			buttons: [
			    {
			        text: Loc.g("Annuler"),
                    click: function() {
			            $(this).dialog("close");
			        }
			        },
                {
					text: Loc.g("Exporter"),
					click: function() {
						var redirectUrl	= false;

						$.ajax({
							url			: MyFacture.buildUrl('listing'),
							type		: 'POST',
							async		: false,
							dataType	: 'json',
							data		: {
								action	: 'doExportCSV',
								charset	: $('#export_charset').val()
							},

							success: function (data) {
								var charset		= data.charset;

								if(charset == ''){
								    MyWindow.close();
								    MyWindow.alert(window.i18n.gettext("Encodage du fichier non reconnu"), {type:'error'})
								} else {
								    redirectUrl = "./?_f=accountingJournal&action=exportListing&journal="+journal+"&charset="+charset;
								}

							}
						});

						if(redirectUrl) {
							Utils.relocate(redirectUrl);

							// puis, on close la popup
							MyWindow.close();

							// et on met l'alert :)
							MyWindow.alert(Loc.g('Votre export a bien été téléchargé.'), {
								'title' : Loc.g('Export des écritures'),
								'buttons' : [{text : Loc.g("Fermer"), click : function(){$(this).dialog("close")}}],
								close : function(){
									Listing.update(listingToUpdate);
								},
								type:'confirm'
							});
						}
					}
				}
			],
			width: 600
		};

		var fileOpt = {action: "exportCSV"};
		MyWindow.load("listing", fileOpt, options);
	},


	/**
	 *
	 * @param {String} doctype
	 * @param {Array} rowSelection
	 * @param {String} comptaAction
	 * @returns {undefined}
	 */
	massCompta: function(doctype, rowSelection, comptaAction) {

		var textAlert;
		var titleAlert;
		var textSucces;

		switch (comptaAction){
			case "mark":
				textAlert	= Loc.g("Veuillez patienter pendant que vos documents sont envoyés en compta") + "<br /> <img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />";
				titleAlert	= Loc.g('Envoyer en comptabilité');
				textSucces	= Loc.g('Envoi en comptabilité réussi');
				break;
			case "remove":
				textAlert	= Loc.g("Veuillez patienter pendant que vos documents sont retirés de votre compta") + "<br /> <img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />";
				titleAlert	= Loc.g('Décomptabilisation');
				textSucces	= Loc.g('Décomptabilisation réussie');
				break;
		}

		MyWindow.alert(
			textAlert,
			{
				'title' : titleAlert,
				'buttons' : [],
				'closeOnEscape' : false
			}
		);

		MyFacture.post(
			"accountingJournal",
			{
				action			: 'massCompta',
				doctype			: doctype,
				selection		: rowSelection,
				comptaAction	: comptaAction
			},
			function(data){
				setTimeout(function(){
					MyWindow.close('alertWindow');

					if (data.status === "ok"){
						var listingsName = {
							'invoice':    'docinvoicesListing',
							'creditnote': 'doccreditnotesListing',
							'purInvoice': 'purdocinvoicesListing'
						};
						MyWindow.alert(
						data.massrecorderresult,
						{
							type	: "confirm",
							title	: textSucces,
							width	: "450",
							buttons : [
								{
									text: Loc.g('Ok'),
									click: function() {
										Utils.reload();
									}
								}
							]
						}
					);
					} else {
						MyWindow.alert(Loc.g("Une erreur est survenue, aucun document n'a été comptabilisé"), {type:'error'});
					}


				}, 1000);
			},
			'json'
		);

	},

	paymentMassCompta: function(rowSelection, comptaAction) {
		var textAlert;
		var titleAlert;
		var textSucces;

		switch (comptaAction){
			case "mark":
				textAlert	= Loc.g("Veuillez patienter pendant que vos remises en banque sont envoyés en compta") + "<br /> <img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />";
				titleAlert	= Loc.g('Envoyer en comptabilité');
				textSucces	= Loc.g('Envoi en comptabilité réussi');
				break;
			case "remove":
				textAlert	= Loc.g("Veuillez patienter pendant que vos remises en banque sont envoyés en compta") + "<br /> <img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />";
				titleAlert	= Loc.g('Décomptabilisation');
				textSucces	= Loc.g('Décomptabilisation réussie');
				break;
		}

		MyWindow.alert(
			textAlert,
			{
				'title' : titleAlert,
				'buttons' : [],
				'closeOnEscape' : false
			}
		);

		MyFacture.post(
			"accountingJournal",
			{
				action			: 'paymentMassCompta',
				selection		: rowSelection,
				comptaAction	: comptaAction
			},
			function(data){
				setTimeout(function(){
					MyWindow.close('alertWindow');

					if (data.status === "ok"){
						MyWindow.alert(
						data.paymentsmassrecordresult,
						{
							type	: "confirm",
							title	: textSucces,
							width	: "450",
							buttons : [
								{
									text: Loc.g('Ok'),
									click: function() {
										Listing.update('bankDepositsListing', true);
										$(this).dialog("close");
									}
								}
							]
						}
					);
					} else {
						MyWindow.alert(Loc.g("Une erreur est survenue, aucun document n'a été comptabilisé"), {type:'error'});
					}

				}, 1000);
			},
			"json"
		);
	}
};
